import { SetterParams } from "./Catcher";

class CacheService {
  cacheOkayMilliseconds = 1000 // Höhere Werte sind möglich, wenn wir keine Fehler eingebaut haben
  cacheTimeMilliseconds = 10000
  counter = 0
  list: {
    hash: string,
    stamp: Date,
    result?: object,
    done: boolean,
  }[] = []

  hash (command: string, body: object, params?: SetterParams): string {
    const useParams = {
      ...(params || {}),
      cacheBreak: false // Damit cacheBreak keinen Einfluss auf den Hash hat
    }
    const data = JSON.stringify({ command, body, useParams });
    let hash = 0;
    for (let i = 0; i < data.length; i++) {
        const char = data.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString();
  }

  tidy () {
    const now = new Date().getTime()
    this.list = this.list.filter(item => now - item.stamp.getTime() < this.cacheTimeMilliseconds)
  }

  set (command: string, body: object, params?: SetterParams, result?: object): void {
    this.tidy()
    const hash = this.hash(command, body, params)
    const item = this.list.find(item => item.hash === hash)
    if (item) {
      item.result = result
      item.stamp = new Date()
      item.done = result ? true : false
    } else {
      this.list.push({ hash, stamp: new Date(), result, done: !!result })
    }
  }

  async get (command: string, body: object, params?: SetterParams): Promise <object | false> {
    return new Promise((success, fail) => {
      // if cache Break is active - do not find in cache!
      if (params?.cacheBreak) {
        this.set(command, body, params)
        success(false)
        return
      }
      this.tidy()
      const hash = this.hash(command, body, params)
      const item = [...this.list].reverse().find(item => item.hash === hash && new Date().getTime() - item.stamp.getTime() < this.cacheOkayMilliseconds)
      if (item) {
        if (item.done && item.result) {
          this.counter++
          console.log('cache hit', this.counter, command, body)
          success(item.result)
        } else {
          let attempts = 0
          const intervalId = setInterval(() => {
            if (item.done) {
              clearInterval(intervalId)
              success(item.result || false)
            } else if (attempts++ > 1000) {
              clearInterval(intervalId)
              success(false)
            }
          }, 10)
        }
      } else {
        this.set(command, body, params)
        success(false)
      }
    })
  }
}

const cacheService = new CacheService()
export default cacheService
